import React, { Fragment } from 'react';
import _ from 'lodash';
import Paper from 'material-ui/Paper/Paper';
import {ElementFactory} from './ScreenElements/Elements';
import LiveExperiment from './../models/LiveExperiment';
import $ from 'jquery';

export default class Experiment extends React.Component {

	constructor(...args){
		super(...args);
		this.handleKeyPress = this.handleKeyPress.bind(this);

		this.experiment = new LiveExperiment(this.props.app, this);
		if(this.props.preview){
			this.experiment.preview = true;
		}
		this.app = this.props.app;
		this.experiment.data = _.cloneDeep(this.props.experimentData);
		this.app.liveExperiment = this.experiment;
		this.experiment.start();
		this.lastScreenIndex = null;
	}

	componentDidUpdate(){
		let currentScreenIndex = this.app.liveExperiment.counter;
		if(currentScreenIndex !== this.lastScreenIndex){
			$(this.node).find('.textfield-element.auto-focus input').focus();
		}
		this.lastScreenIndex = currentScreenIndex;
	}

	componentDidMount(){
		
	}
	
	componentWillUnmount(){
		this.experiment.cancelled = true;
		this.experiment.cleanup();
	}

	handleKeyPress(event){
		if(['TEXTAREA','SELECT'].includes(event.target.tagName)){return;}
		if(event.key === 'Enter'){
			$(this.node).find('.button-element.submit-on-enter').last().focus().trigger('click');
		}
	}

	render(){
		let experiment = this.experiment;
		let screen = this.experiment.currentScreen;

		if(!screen){
			return null;
		}

		//console.log('get the correct width and height');

		return (
			<Fragment>
				<Paper elevation={1} style={{width:`${experiment.data.width}px`, height:`${experiment.data.height}px`, margin:'20px auto 20px auto'}}>
					<div 
						ref={ n => this.node = n } 
						style={{position:'relative'}}
						onKeyPress={ this.handleKeyPress }
						>
						{(screen._parsedElements || []).map( (element, i) => {
							return <ElementFactory live element={element} key={`${i}_${element.id}`} experiment={experiment} /> 
						})}
					</div>
				</Paper>
				{!!this.experiment.preview &&
					<div style={{position:'absolute', left:0, right:0, bottom:0}}>
						<a onClick={ e => { experiment.app.showLog = !experiment.app.showLog; experiment.forceUpdate() }}>Log</a>
						<div className="Preview-log" style={{display:experiment.app.showLog ? 'block' : 'none'}}>
							{ JSON.stringify(experiment.flattenedResponse, null, '\t') }
						</div>
					</div>
				}
			</Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/LiveExperiment.js